export const useArticleProfileCommentColor = () => {
  onMounted(() => {
    // NOTE: profileとコメントの色を一致させる
    const profileElms = document.getElementsByClassName(
      'article-profile-box__content',
    );
    const blCommentElms = document.getElementsByClassName(
      'balloon-comment-content',
    );
    const profileElements = Array.from(profileElms) as HTMLElement[];
    const blCommentElements = Array.from(blCommentElms) as HTMLElement[];
    profileElements.forEach((p) => {
      const backgroundColor = window.getComputedStyle(p).backgroundColor;
      const cleanedProfileId = p.id.split('-').pop() ?? '';
      blCommentElements.forEach((b) => {
        const cleanedCommentId = b.id.split('-')[0];
        if (cleanedProfileId.includes(cleanedCommentId)) {
          b.style.backgroundColor = backgroundColor;
          if (
            b.className.includes('balloon-comment-content-right') &&
            backgroundColor === 'rgb(255, 255, 255)'
          ) {
            b.classList.add('balloon-comment-content-right-white');
          } else if (
            b.className.includes('balloon-comment-content-left') &&
            backgroundColor === 'rgb(236, 240, 250)'
          ) {
            b.classList.add('balloon-comment-content-left-blue');
          }
        }
      });
    });
  });

  return {};
};
